import React from "react";
import Form, { Group } from "~/common/components/Form";
import Input from "./newComp/Input";
import DatePicker from "./newComp/DatePicker";
import MultiCheckboxSelect from "~/common/components/MultiCheckboxSelect";
import Select from "~/common/components/Select";
import Textarea from "./newComp/Textarea";
import Tag from "./newComp/Tag";
import FileUploader from "./newComp/FileUploader";
import Address from "./newComp/Address";
import Radio from "./newComp/Radio";
import ViewTitle from "./viewTitle";
import { UPLOAD_TYPE } from "~/common/constants/upload";
import lightLogo from "~/assets/img/logo-black.svg";
import { INVEST_LEVEL } from "~/constant/ApplyFormConstant";

const FIELD_VALUE = {
	기업명: "companyName",
	"대표자 이름": "ceoName",
	"대표자 이메일": "ceoEmail",
	설립연월: "esDate",
};
const ViewInquery = ({
	applyForm,
	applyQuestList,
	setListByTarget,
	inquiryFinalList,
	setInquiryFinalList,
	submit,
}) => {
	let catNum = 0;
	let subNum = 0;
	const addCatNum = () => {
		catNum++;
		subNum = 0;
	};

	const country = applyForm.watch("company.country") || "";
	const handleChange = (e, card) => {
		setListByTarget({ ...card, answer: e.target.value });
	};
	const handleRadioChange = (e, card) => {
		setListByTarget({ ...card, answer: e });
	};
	const handleCheckboxChange = (e, card) => {
		setListByTarget({ ...card, answer: e.target.checked });
	};
	const handleAddress1Change = (e, card) => {
		setInquiryFinalList(
			inquiryFinalList.map((value) =>
				value.order === card.order ? { ...value, address1: e } : value
			)
		);
	};
	const handleAddress2Change = (e, card) => {
		setInquiryFinalList(
			inquiryFinalList.map((value) =>
				value.order === card.order ? { ...value, address2: e } : value
			)
		);
	};

	const handleTagChange = (e, card) => {
		setInquiryFinalList(
			inquiryFinalList.map((value) =>
				value.order === card.order ? { ...value, answer: e } : value
			)
		);
	};

	const handleFileChange = (e, card) => {
		setInquiryFinalList(
			inquiryFinalList.map((value) =>
				value.order === card.order ? { ...value, answer: e } : value
			)
		);
	};

	return (
		<>
			<div className="apply-form-wrap share">
				<Form useForm={applyForm} className="apply-form light">
					{applyQuestList &&
						applyQuestList.length > 0 &&
						applyQuestList.map((inquiry, index) => {
							switch (inquiry.type) {
								case "CATEGORY":
									addCatNum();
									return (
										<ViewTitle
											title={catNum + "." + inquiry.title}
											description={inquiry.description}
										/>
									);
								case "SHORT":
									subNum++;
									if (inquiry.disabled)
										return (
											<Input
												label={
													"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title
												}
												name={FIELD_VALUE[inquiry.title]}
												required={inquiry.isRequired}
												limitLength={40}
												// className="f__column"
												// getValue={handleRadioChange}
												// card={inquiry}
											/>
										);
									else
										return (
											<Input
												label={
													"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title
												}
												name={inquiry.title}
												required={inquiry.isRequired}
												className="f__column"
												getValue={handleRadioChange}
												card={inquiry}
											/>
										);
								case "LONG":
									subNum++;
									return (
										<Textarea
											label={
												"[" + catNum + "-" + subNum + "] " + inquiry.title
											}
											name={inquiry.title}
											required={inquiry.isRequired}
											className="f__column"
											getValue={handleRadioChange}
											card={inquiry}
											maxLength={1000}
											showCount={true}
										/>
									);

								case "CHOICE":
									subNum++;
									return (
										<Radio
											label={
												"[" + catNum + "-" + subNum + "] " + inquiry.title
											}
											name={inquiry.title}
											options={inquiry?.option.map((q) => {
												return { label: q, value: q };
											})}
											required={inquiry.isRequired}
											className="c__tag-wrap f__column"
											getValue={handleRadioChange}
											card={inquiry}
										/>
									);
								case "ALTERNATIVE":
									const optionsDataAlter = inquiry.option?.map((dt) => {
										return { label: dt, value: dt };
									});
									subNum++;
									return (
										<Radio
											label={
												"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title || " 이지선다"
											}
											name={inquiry.title}
											key={index}
											required={inquiry.isRequired}
											options={optionsDataAlter}
											className="c__tag-wrap f__column"
											getValue={handleRadioChange}
											card={inquiry}
										/>
									);

								case "TAG":
									subNum++;
									return (
										<Tag
											label={
												"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title || "태그"
											}
											name={inquiry.order.toString()}
											key={index}
											className="c__tag-wrap f__column"
											required={inquiry.isRequired}
											getValue={handleTagChange}
											card={inquiry}
										/>
									);
								case "FILE":
									subNum++;
									return (
										<Group
											label={
												"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title || "첨부파일"
											}
											key={index}
											className="file-upload f__column"
											required={inquiry.isRequired}
										>
											<FileUploader
												name="file"
												type={UPLOAD_TYPE.COMMON}
												format=".pdf, .hwp, .docx, .xlsx, .ppt, ,pptx, .jpg, .jpeg, .png, .keynote"
												onChangeFile={handleFileChange}
												card={inquiry}
											/>
											<ul className="note-list">
												{inquiry.description &&
													inquiry.description.split("\n").map((text) => {
														return (
															<li>
																<span>
																	{text}
																	<br />
																</span>
															</li>
														);
													})}
												<li className="default-note">
													최대 업로드 파일 크기: 100MB
												</li>
											</ul>
										</Group>
									);
								case "LINK":
									subNum++;
									return (
										<Input
											label={
												"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title || "링크 연결"
											}
											name="url"
											type="url"
											required={inquiry.isRequired}
											className="f__column"
											getValue={handleRadioChange}
											card={inquiry}
											placeholder="https://www.example.com"
										/>
									);
								case "DATE":
									subNum++;
									if (inquiry.disabled) {
										return (
											<DatePicker
												label={
													"[" +
														catNum +
														"-" +
														subNum +
														"] " +
														inquiry.title || "날짜"
												}
												name={"esDate"}
												// key={index}
												// className="c__tag-wrap f__column"
												required={inquiry.isRequired}
												className="light"
											/>
										);
									} else
										return (
											<DatePicker
												label={
													"[" +
														catNum +
														"-" +
														subNum +
														"] " +
														inquiry.title || "날짜"
												}
												name={inquiry.order.toString()}
												key={index}
												className="c__tag-wrap f__column"
												required={inquiry.isRequired}
												getValue={handleTagChange}
												card={inquiry}
											/>
										);
								case "AGREE":
									subNum++;
									return (
										<Group
											label={
												"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title || "동의"
											}
											className="c__agree"
										>
											<Textarea
												name="agree"
												placeholder={inquiry.description}
												readonly={true}
											/>
											<label className={`checkbox-custom`}>
												<input
													type="checkbox"
													name={
														inquiry.order.toString() +
														"_" +
														inquiry.title
													}
													onChange={(e) =>
														handleCheckboxChange(e, inquiry)
													}
												/>
												<span className="checkmark" />
												<span className="checkbox-label">
													{inquiry.agreeDescription}
												</span>
											</label>
										</Group>
									);
								case "ADDRESS":
									subNum++;
									return (
										<Address
											label={
												"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title || "주소작성"
											}
											name={{
												postCode: "zipCode",
												address1: "address",
												address2: "addressDetail",
											}}
											required={inquiry.isRequired}
											handleAddress1Change={handleAddress1Change}
											handleAddress2Change={handleAddress2Change}
											card={inquiry}
										/>
									);
								case "TEXT":
									return (
										<p
											className="certified-phrase"
											style={{
												color:
													inquiry.description === "red"
														? "#ff3c00"
														: inquiry.description === "blue"
														? "#00a4ff"
														: inquiry.description === "green"
														? "#71bb30"
														: "#ffd800",
											}}
										>
											{inquiry.title}
										</p>
									);
								case "SELECT":
									subNum++;
									if (inquiry.title === "국가" && inquiry.disabled)
										return (
											<>
												<Select
													label={
														"[" +
														catNum +
														"-" +
														subNum +
														"] " +
														inquiry.title
													}
													name="company.country"
													options={[
														{
															label: "한국",
															value: "korea",
														},
														{
															label: "일본",
															value: "japan",
														},
														{
															label: "미국",
															value: "usa",
														},
														{
															label: "중국",
															value: "china",
														},
														{
															label: "베트남",
															value: "vietnam",
														},
														{
															label: "기타",
															value: "etc",
														},
													]}
													className="f__column"
													required
												/>
												{country === "etc" ? (
													<Input
														name="etcCountry"
														required={inquiry.isRequired}
														className="f__column etc-country"
														getValue={handleRadioChange}
														card={inquiry}
														placeholder="국가를 입력해주세요."
													/>
												) : (
													<></>
												)}
											</>
										);
									else if (inquiry.title === "투자단계")
										return (
											<Select
												label={
													"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title
												}
												name="company.investLevel"
												options={INVEST_LEVEL}
												required
												className="f__column"
											/>
										);
									else
										return (
											<>
												<Select
													label={
														"[" +
														catNum +
														"-" +
														subNum +
														"] " +
														inquiry.title
													}
													name={inquiry.title}
													options={inquiry?.option.map((q) => {
														return { label: q, value: q };
													})}
													getValue={handleRadioChange}
													required={inquiry.isRequired}
													className="c__tag-wrap f__column"
													card={inquiry}
												/>
											</>
										);
								case "MULTISELECT":
									subNum++;
									if (inquiry.title === "산업분야" && inquiry.disabled)
										return (
											<Tag
												label={
													"[" +
													catNum +
													"-" +
													subNum +
													"] " +
													inquiry.title
												}
												name={"industrytype"}
												key={index}
												className="c__tag-wrap f__column"
												required
												getValue={handleTagChange}
												card={inquiry}
											/>
										);
									else {
										return (
											<>
												<MultiCheckboxSelect
													label={
														"[" +
														catNum +
														"-" +
														subNum +
														"] " +
														inquiry.title
													}
													valueKey={"value"}
													name={`multiselect.${inquiry.title}`}
													options={inquiry?.option.map((q) => {
														return { label: q, value: q };
													})}
													placeholder={"선택해주세요."}
													required={inquiry.isRequired}
													selectedValues={[]}
													className="f__column"
												/>
											</>
										);
									}
								default:
									return <></>;
							}
						})}
				</Form>
				<div className="apply-form-btn">
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={applyForm.handleSubmit(submit)}
					>
						제출하기
					</button>
				</div>
				<div className="form-footer">
					<div className="img-wrap">
						<img src={lightLogo} alt="로고 이미지" />
					</div>

					<p className="gitbal-explain">
						스타트업과 투자자를 연결하는 [깃발] 플랫폼에서는 스타트업의 성장을 위해
						다양한 서비스를 제공하고 있습니다. 지금 바로 경험하세요.
						<button type="button" className="btn-link">
							<a href={"https://startup.gitbal.io"}>깃발 바로가기</a>
						</button>
					</p>
				</div>
			</div>
		</>
	);
};

export default ViewInquery;
